/**
 * Lab player-only Net Exposure tab — open books for the selected member.
 * Sportsbook getBooksForBackend + Premium BM (PB) + Details (Agent Portal parity).
 */

import { useState } from 'react'
import { Card } from '@w7/ui'
import { usePlayerBooks } from '@/api/hooks/net-exposure/usePlayerBooks'
import {
  EventBooksTable,
  type EventBooksDetailsPayload,
} from '@/features/net-exposure/EventBooksTable'
import { PlayerExposureBetsModal } from '@/features/member/PlayerExposureBetsModal'
import type { MemberAccount } from '@/features/member/memberAccount'
import '@/features/net-exposure/net-exposure.css'

export function NetExposureTab({ account }: { account: MemberAccount }) {
  const books = usePlayerBooks(account.id)
  const events = books.data ?? []
  const [details, setDetails] = useState<EventBooksDetailsPayload | null>(null)

  return (
    <div className="w7-col w7-ne" style={{ gap: 'var(--w7-s5)' }}>
      <Card flush title="Net Exposure" subtitle={`${account.username} · open books`}>
        {books.isLoading ? (
          <div className="w7-ne-empty">Loading open books…</div>
        ) : books.isError ? (
          <div className="w7-ne-empty">
            Could not load books
            {books.error instanceof Error && books.error.message
              ? `: ${books.error.message}`
              : ''}
          </div>
        ) : events.length === 0 ? (
          <div className="w7-ne-empty">No Data Found</div>
        ) : (
          <div className="w7-ne-events">
            {events.map((event) => (
              <EventBooksTable
                key={event._id}
                event={event}
                book="Total Book"
                actions="details"
                onDetails={setDetails}
              />
            ))}
          </div>
        )}
      </Card>

      {details ? (
        <PlayerExposureBetsModal
          open
          onClose={() => setDetails(null)}
          playerId={account.id}
          playerUsername={account.username}
          marketId={details.marketId}
          marketName={details.marketName}
        />
      ) : null}
    </div>
  )
}
